import { useCallback, useEffect, useState } from "react";
import axios from "../api/axios";
import { formatPermissionLabel } from "../constants/permissionLabels";

interface Permission {
  id: string;
  code: string;
  roleId: string;
}

export default function PermissionList({ reload }: { reload: boolean }) {
  const [permissions, setPermissions] = useState<Permission[]>([]);

  const fetchPermissions = useCallback(async () => {
    try {
      const res = await axios.get("/permission");
      const unique = Array.from(new Map((res.data ?? []).map((p: Permission) => [p.code, p])).values());
      setPermissions(unique as Permission[]);
    } catch (error) {
      console.error("[permissions] alınamadı", error);
      setPermissions([]);
    }
  }, []);

  useEffect(() => {
    fetchPermissions();
  }, [reload, fetchPermissions]);

  return (
    <div className="rounded bg-white p-4 shadow">
      <h3 className="mb-4 text-md font-semibold">Tüm İzinler</h3>
      <ul className="space-y-2">
        {permissions
          .sort((a, b) => formatPermissionLabel(a.code).localeCompare(formatPermissionLabel(b.code), "tr-TR"))
          .map((perm) => (
            <li key={perm.id} className="flex items-center justify-between rounded border p-2 shadow-sm">
              <span>{formatPermissionLabel(perm.code)}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}
